import React from 'react';
import classnames from 'classnames';
import { findDOMNode } from "react-dom";
import { DragDropContextProvider, DragSource, DropTarget } from 'react-dnd';
import HTML5Backend from 'react-dnd-html5-backend';
import './index.less';

class Dnd extends React.Component{
    constructor(props){
        super(props);
        this.state = { dragIndex: -1 };
    }

    render(){
        return (
            <DragDropContextProvider backend={HTML5Backend} >
                <div className="dnd-list">
                    {
                        this.props.list.map((renderItem, index) => <DragItem 
                            key={renderItem.key}
                            item={renderItem}
                            index={index}
                            onStart={index => this.setState({ dragIndex: index })}
                            onStop={() => this.setState({ dragIndex: -1 })}
                            onDrop={this.handleDrop}
                            onHover={this.handleHover}
                        />)
                    }
                </div>
            </DragDropContextProvider>
        );
    }

    handleDrop = dropIndex => {
        const { onStop } = this.props;
        const { dragIndex } = this.state;
        if(dropIndex === -1){
            console.warn('something wrong, no drag item');
        }
        onStop?.(dragIndex, dropIndex);
    }

    handleHover = (dragIndex, hoverIndex) => {
        let item = this.props.list.splice(dragIndex, 1);
        this.props.list.splice(hoverIndex, 0, item[0]);
        this.forceUpdate();
    }
}

export default Dnd;

//  流程 beginDrag -- hover -- drop -- endDrag
const ItemTypes = { ITEM: 'item' };
const sourceActions = { // 拖拽起始相关函数
    beginDrag(props) { // 开始拖拽，存储拖拽下标
        props.onStart?.(props.index);
        return { index: props.index }; // monitor.getItem的数据
    },
    endDrag(props) { // 结束拖拽，清除拖拽下标
        props.onStop?.(props.index);
    },
    canDrag(props) {
        return props.item.props.draggable;
    },
};
const destinationActions = {
    drop(props) { // 放置，此时monitor存储的index已经变了(hover已交换位置)
        const dropIndex = props.index;
        props.onDrop?.(dropIndex);
    },

    // hover到Item，根据是否超过hover Item高度的一半来判断是否需要重新排序
    hover(props, monitor, component) { // hover发生（位置过半） 交换位置
        if(!props.item.props.draggable) return; //不支持拖拽的不处理
        
        let item = monitor.getItem();
        const dragIndex = item.index;
        const hoverIndex = props.index;

        if (dragIndex === hoverIndex) return; // hover结束后，index已变，此时会相等

        // hover项DOM的边界
        const hoverBoundingRect = findDOMNode(component).getBoundingClientRect();

        // hover项的中间位置
        const hoverMiddleY = (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2;

        // 拖拽项的偏移量
        const clientOffset = monitor.getClientOffset();

        // 拖拽项距离hover项 顶部的偏移量
        const hoverClientY = clientOffset.y - hoverBoundingRect.top;
        if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) {
            return;
        }

        if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) {
            return;
        }

        props.onHover?.(dragIndex, hoverIndex);
        monitor.getItem().index = hoverIndex;
    },

    canDrop(props) {
        return props.item.props.draggable;
    },
};

@DropTarget(ItemTypes.ITEM, destinationActions, connect => ({ connectDropTarget: connect.dropTarget() }))
@DragSource(ItemTypes.ITEM, sourceActions, (connect, monitor) => ({ connectDragSource: connect.dragSource(), isDragging: monitor.isDragging() }))
class DragItem extends React.Component {
    render() {
        const {
            connectDragSource,
            connectDropTarget,
            isDragging,
            item,
        } = this.props;
        return (
            <>
                {connectDropTarget(connectDragSource(
                    <div className={classnames("dnd-item", { dragging: isDragging })}>
                        {item}
                    </div>,
                ))}
            </>
        );
    }
}